import { z } from "zod";

// Bucket 8 — admin portal-content + FAQ. Replaces
// /app/admin/portal-content/_actions.ts.
//
// The legacy Zod schemas (portalContentWriteSchema, portalFaqItemWriteSchema,
// portalWelcomeContentSchema, portalLevelUpContentSchema,
// portalSupportLinksContentSchema, PortalContentKey) already live in
// `../domain` and are re-exported from `@colab/shared` via the package
// index. This file only adds the request-body schema for the FAQ reorder
// endpoint, which doesn't have a domain analogue.

export const faqReorderRequestSchema = z.object({
  category: z.string().min(1),
  orderedIds: z.array(z.string().uuid()).min(1),
});
export type FaqReorderRequest = z.infer<typeof faqReorderRequestSchema>;
